import NetworkService from '../services/network.service'

class EstimateApi {
  getEstimates = async (query: any, isIndependent = false) => {
    let url = `api/estimates`;
    let config = {
      params: {
        query: query,
        isIndependent: isIndependent
      }
    }
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data

  };
  deleteEstimate = async (id: any) => {
    try {
      let url = `api/estimates/delete`;
      let body = { id: id };
      let data = await NetworkService.delete(url, body)
      return data && data.data
        ? data.data : data
    } catch (err: any) {
      return err.description ? err.description : err;
    }
  }

  fetchEstimateRejectionReasons = async (query: any = {}) => {
    try {
      let url = `api/estimates/rejection-reasons/list`;
      let data = await NetworkService.post(url, query);
      return data && data.data ? data.data : data;
    } catch (err: any) {
      return err.description ? err.description : err;
    }
  }

  addEstimateRejectionReason = async (payload: { reason: string; reasonType?: string }) => {
    try {
      let url = `api/estimates/rejection-reasons`;
      let data = await NetworkService.post(url, payload);
      return data && data.data ? data.data : data;
    } catch (err: any) {
      return err.description ? err.description : err;
    }
  }
  // following function is not used
  deleteEstimates = async (estimateId: any) => {
    let url = `api/estimates`;
    let body = {
      id: estimateId
    }
    let data = await NetworkService.delete(url, body)
    return data && data.data
      ? data.data : data
  }
}
export default EstimateApi;
